import styled from 'styled-components';

export const EnrollmentChangesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-grow: 2;
  background-color: #fff;
  min-width: 0px;
`;

export const EnrollmentChangesTitle = styled.p`
  font-size: 24px;
  font-weight: 600;
  color: #1c1b3a;
  padding: 10px 0 0 20px;
  margin-bottom: 10px;
`;

export const EnrollmentTypeTitle = styled.p`
  font-size: 20px;
  font-weight: 600;
  color: #1c1b3a;

  margin-bottom: 10px;
`;

export const EnrollmentChangesGridContainer = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  margin: 20px;
  &::-webkit-scrollbar {
    width: 10px;
    height: 7px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
